import React from 'react';
import { Button, Space } from 'antd';
import { LeftCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import '../../ExpandedMapView/ExpandedMapView.scss';
import PrintIcon from '../../../../assets/icons/map-print.svg';
import SettingsIcon from '../../../../assets/icons/map-setting.svg';
import HelpIcon from '../../../../assets/icons/map-help.svg';
import { useAuth } from '../../../../context/AuthContext';
import { MapToolAction } from '../../../../enums/mapPortalActions';
import { mapToolAccess } from '../../constants';
import ConditionalRender from '../../../../shared/components/ConditionalRender';

interface MapPortalToolbarProps {
  onShowSettings: () => void;
  onPrint: () => void;
}

const MapPortalToolbar: React.FC<MapPortalToolbarProps> = ({ onShowSettings, onPrint }) => {
  const navigate = useNavigate();
  const { canAccess } = useAuth();
  const canOpenSettings = canAccess(mapToolAccess(MapToolAction.OPEN_MAP_SETTINGS));

  const handleHelpClick = () => {
    const url = 'https://files.mapaki.ca/Documents/MAPAKI%20QUICK%20START%20GUIDE%202021.pdf';
    window.open(url, '_blank');
  };

  return (
    <>
      <Button className="header-buttons custom-button" icon={<LeftCircleOutlined className="custom-icon" />} onClick={() => navigate(-1)} />
      <Space className="header-buttons">
        <button className="custom-button" type="button" onClick={onPrint}>
          <PrintIcon />
        </button>
        <ConditionalRender visible={canOpenSettings}>
          <button className="custom-button" type="button" onClick={onShowSettings}>
            <SettingsIcon />
          </button>
        </ConditionalRender>
        <button className="custom-button" type="button" onClick={handleHelpClick}>
          <HelpIcon />
        </button>
      </Space>
    </>
  );
};

export default MapPortalToolbar;
